import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'skeleton-image',
  styleUrl: '../shine-effect.css',
})
export class SkeletonImage {
  @Prop() inverse: boolean = false;

  render() {
    const classes = {
      'text-center w-10 h-10 shine skeleton-item': true,
      'skeleton-item--inverse': this.inverse,
    };
    return (
      <div class={classes}>
        <svg-icon icon="skeleton-loading-image" class="self-center justify-self-center w-10 h-10" />
      </div>
    );
  }
}
